import BaseModel from '../core/BaseModel'
export default class AreaModel extends BaseModel {

    constructor() {
        super({ 
                name: "area",
                tableName: 'area', 
                label: "Quản lý khu vực", 
                display_key: 'code',
                default_order: { key: 'id', direction: 'asc' } }, 
            {
            // stt: {
            //     name: "stt",
            //     label: "STT",
            //     type: "Computed",
            //     computed: (data, index) => {
            //         data.stt = index + 1;
            //     },
            //     // display: { list: true, add: false, edit: false }
            // },
            id: { 
                name: 'id', 
                type: "Int", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            code: {
                name: 'code', 
                type: "String",
                label: 'Mã khu vực quản lý',
                width :6,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            address: {
                name: 'address', 
                type: "String",
                label: 'Địa chỉ',
                width :15,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            area_district: {
                name: 'area_district', 
                type: "String",
                label: 'Quận/Huyện quản lý',
                width :10, 
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            //xa/phuong quan ly
            area_ward_str: {
                name: 'area_ward_str', 
                type: "String",
                label: 'Xã/Phường quản lý',
                width :10, 
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },

        },)
    }

}